export default {"src":"/_next/static/media/StatusBadges.45bd240c.svg","height":22,"width":34,"blurWidth":0,"blurHeight":0};